module.exports = __webpack_public_path__ + "static/LaptopPlatformEN-2db71f97f9ef17bb887bd51b5efe9786.mp4";